// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EywS","importantInfo":"styles_importantInfo__3vVQe"};